import { CheckItem } from '@rpe/registro-personas-empresas-lib';

export interface GrupoEspecieFormInput {
  listaCheckItem: CheckItem[];
  entidad_productiva_id: number;
}

export function createEmptyGrupoEspecieFormInput(): GrupoEspecieFormInput {
  return {
    listaCheckItem: [],
    entidad_productiva_id: null
  };
}
